/**
 * Une seule proposition de mise à jour par session de page, quel que soit le chemin :
 * le toast de useAutoUpdate et la mise à jour guidée des anciens APK partagent ce verrou
 * pour ne jamais s'afficher l'un par-dessus l'autre.
 */

let webUpdateShown = false;

export function isWebUpdateShown(): boolean {
  return webUpdateShown;
}

export function markWebUpdateShown(): void {
  webUpdateShown = true;
}
